// extracted by mini-css-extract-plugin
module.exports = {"paginado":"Paginado_paginado__2HU61","li":"Paginado_li__75TAi","btn":"Paginado_btn__1nkGZ"};